import { render, staticRenderFns } from "./OperationTags.vue?vue&type=template&id=33662152&scoped=true"
import script from "./OperationTags.vue?vue&type=script&lang=ts"
export * from "./OperationTags.vue?vue&type=script&lang=ts"
import style0 from "./OperationTags.vue?vue&type=style&index=0&id=33662152&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33662152",
  null
  
)

export default component.exports